import { format, isValid, parseISO } from 'date-fns';


const CLIENT_OFFSET = new Date().getTimezoneOffset(); // Local time offset in minutes

const isValidISODateString = (dateStr: string): boolean => {
	if (!dateStr || typeof dateStr !== 'string') return false;
	try {
		const date = parseISO(dateStr);
		return isValid(date);
	} catch {
		return false;
	}
};

const formatTimeString = (timeStr: string, formatStr: string): string => {
	if (!isValidISODateString(timeStr)) {
		return '';
	}
	const date = parseISO(timeStr);
	return format(date, formatStr);
};

const gmtMinus4ToClient = (gmt4DateStr: string, formatStr?: string): string => {
	if (!isValidISODateString(gmt4DateStr)) {
		return '';
	}
	const date = parseISO(gmt4DateStr);
	
	const utcDate = new Date(date.getTime() + (4 * 60 * 60 * 1000));
	
	const clientDate = new Date(utcDate.getTime() - (CLIENT_OFFSET * 60 * 1000));

	if (formatStr) {
		return format(clientDate, formatStr);
	}

	return clientDate.toISOString();
}

const clientToGmtMinus4 = (clientDateStr: string, formatStr?: string): string => {
	if (!isValidISODateString(clientDateStr)) {
		return '';
	}

	const date = parseISO(clientDateStr);
	
	const utcDate = new Date(date.getTime() + (CLIENT_OFFSET * 60 * 1000));
	
	const gmt4Date = new Date(utcDate.getTime() - (4 * 60 * 60 * 1000));

	if (formatStr) {
		return format(gmt4Date, formatStr);
	}

	return gmt4Date.toISOString();
}

export const goldenDuelTimezoneService = {
	gmtMinus4ToClient,
	clientToGmtMinus4,
	formatTimeString
}